// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__30AT5","left":"StickyBox_left__35FzC","right":"StickyBox_right__1T4H2"};